import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const CommuteScooter = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M24 14V11.828C24.313 11.939 24.649 12 25 12H27C27.552 12 28 11.552 28 11V7C28 6.448 27.552 6 27 6H25C24.232 6 23.531 6.29 23 6.766C22.469 6.29 21.768 6 21 6H19C18.448 6 18 6.448 18 7C18 7.552 18.448 8 19 8H21C21.551 8 22 8.449 22 9V14.344C19.672 15.17 18 17.393 18 20H16V15C16 12.243 13.757 10 11 10H5C4.448 10 4 10.448 4 11C4 12.52 4.682 13.882 5.756 14.8C3.526 15.972 2 18.311 2 21C2 21.552 2.448 22 3 22H4C4 24.206 5.794 26 8 26C10.206 26 12 24.206 12 22H20C20 24.206 21.794 26 24 26C26.206 26 28 24.206 28 22H29C29.552 22 30 21.552 30 21V20C30 16.692 27.308 14 24 14ZM25 8H26V10H25C24.449 10 24 9.551 24 9C24 8.449 24.449 8 25 8ZM6.171 12H11C12.304 12 13.416 12.836 13.829 14H9C7.696 14 6.584 13.164 6.171 12V12ZM8 24C6.897 24 6 23.103 6 22H10C10 23.103 9.103 24 8 24ZM4.101 20C4.566 17.721 6.586 16 9 16H14V20H4.101V20ZM24 24C22.897 24 22 23.103 22 22H26C26 23.103 25.103 24 24 24ZM20 20C20 17.794 21.794 16 24 16C26.206 16 28 17.794 28 20H20Z" />
	</svg>
);

export default CommuteScooter;
